import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";

import CardWrapper from "cards/components/CardWrapper";
import styles from "./PromoStreamCap.css";
import { promoInViewDataLayerEvent } from "utils/analytics";

class PromoStreamCap extends Component {
  componentDidMount() {
    promoInViewDataLayerEvent("stream_cap_promo", {
      ...this.props.promo,
      content: this.props.promo.contentForAnalytics || this.props.promo.content,
    });
  }

  render() {
    const { promo } = this.props;

    return (
      <CardWrapper className={classNames(styles.root, "gtm-promo-stream-cap")}>
        <div className={styles.content}>
          {promo.link ? (
            <h4>
              <Link
                to={promo.link}
                className={classNames(
                  styles.title,
                  styles.link,
                  "gtm-stream-cap-promo-link"
                )}
              >
                {promo.title}
              </Link>
            </h4>
          ) : (
            <h4 className={styles.title}>{promo.title}</h4>
          )}
          <p className={styles.paragraph}>{promo.content}</p>
        </div>
        {promo.image && <img className={styles.image} src={promo.image} />}
      </CardWrapper>
    );
  }
}

PromoStreamCap.propTypes = {
  promo: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    link: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
};

export default PromoStreamCap;
